module.exports = __webpack_public_path__ + "img/pr-5.34ffe7bd.png";